<template>
  <ul-page higher :fullHeader="false" class="page-virtual-home">
    <template v-slot:right>
      <div class="page-header-right">
        <LoginUser></LoginUser>
      </div>
    </template>
    <div class="page-top">
      <div class="page-top-shadow">
        <div class="content">
          <div class="cover">
            <img :src="virtual.cover" alt="">
          </div>
          <div class="detail">
            <div class="title" :title="virtual.title">{{virtual.title}}</div>
            <div class="teacher">教师：{{virtual.teacherName}}</div>
            <ul class="info-list">
              <li>
                <div class="value">{{virtual.pageView || 0}}</div>
                <div class="label"> <i class="iconfont icon-pageviews_stroke"></i><span>浏览量</span></div>
              </li>
              <li>
                <div class="value">{{virtual.experimentTimes || 0}}</div>
                <div class="label"> <i class="iconfont icon-person-times_stroke"></i><span>实验人次</span></div>
              </li>
              <li>
                <div class="value">{{virtual.experimentPeoples || 0}}</div>
                <div class="label"> <i class="iconfont icon-person-number_stroke"></i><span>实验人数</span></div>
              </li>
              <li>
                <div class="value">{{virtual.averageTime | duration}}</div>
                <div class="label"> <i class="iconfont icon-xunifangzhen_shiyanleijiyongshi"></i><span>实验平均用时</span></div>
              </li>
              <li>
                <div class="value">{{virtual.passRate || 0}}%</div>
                <div class="label"> <i class="iconfont icon-pass-rate_stroke"></i><span>实验通过率</span></div>
              </li>
            </ul>
            <div class="bt-wrapper">
              <ul-button type="primary" icon="icon-xunifangzhen_shiyancishu" @click="startTest">开始实验</ul-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main-content">
      <div class="tabs-wrapper">
        <div class="tabs">
          <div class="tab" :class="{'is-active': tabIndex === 0}" @click="tabChange(0)">实验介绍</div>
          <div class="tab" :class="{'is-active': tabIndex === 1}" @click="tabChange(1)">实验指南</div>
          <div class="tab" :class="{'is-active': tabIndex === 2}"  @click="tabChange(2)">师资介绍</div>
        </div>
      </div>
      <div class="tab-content tab-detail" v-show="tabIndex === 0">
        <richtext :content="virtual.experimentIntroduce"></richtext>
      </div>
      <div class="tab-content tab-index" v-show="tabIndex === 1">
        <richtext :content="virtual.guideIntroduce"></richtext>
      </div>
      <div class="tab-content tab-index" v-show="tabIndex === 2">
        <richtext :content="virtual.teacherIntroduction"></richtext>
      </div>
    </div>
  </ul-page>
</template>

<script>
import { device } from '@/utils/device.js'
if (device.isMobile) {
  location.href = location.href.replace('pc.html', 'mobile.html')
}
import LoginUser from 'pc/components/page/user'
import { mapGetters } from 'vuex'
import { getVirtualExperimentUrl, getVirtualExperimentDetail, updateVirtualHomeViewTimes } from '@/api/courseApi/virtual.js'
import cookies from '@/utils/cookie'
import Confirm from 'pc/components/confirm'
import { formatSeconds } from '@/utils'
import Richtext from 'pc/components/richtext.vue'
export default {
  name: 'page-virtual-home',
  data () {
    return {
      tabIndex: 0,
      virtual: {

      }
    }
  },
  computed: {
    ...mapGetters({'user': 'user/user', 'org': 'org/org'}),
    experimentId () {
      return this.$route.params.id
    }
  },
  created () {
    window.virtual = this
    this.getVirtualDetail()
  },
  mounted () {
    this.updateViewTimes()
  },
  methods: {
    getVirtualDetail () {
      getVirtualExperimentDetail({experimentId: this.experimentId})
        .then(({result}) => {
          this.virtual = result
        })
    },
    updateViewTimes () {
      updateVirtualHomeViewTimes({experimentId: this.experimentId})
    },
    tabChange (index) {
      this.tabIndex = index
    },
    startTest () {
      if (this.user.userId) {
        if (this.user.role == 8) {
          // 当前登录的是教师帐号，请切换到学生模式再加入课程！
          Confirm({
            content: '当前登录的是教师帐号，请切换到学生模式再开始实验！',
            confirmText: '切换到学生模式',
            onConfirm: this.switchRole
          })
        } else if (this.user.role == 9) {
          getVirtualExperimentUrl({experimentId: this.experimentId})
            .then(({result}) => {
              window.open(result)
            })
        } 
        
      } else {
        this.toLogin()
      }
    },
    switchRole () {
      this.user.switchRole()
    },
    logout () {
      this.user.logout()
    },
    toLogin () {
      cookies.set('loginRedirectUrl', location.href)
      this.$router.push({
        path: '/login'
      })
    }
  },
  filters: {
    duration (time) {
      if (time === undefined) {
        return '--'
      }
      return formatSeconds(time)
    },
  },
  components: {
    LoginUser,
    Richtext
  }
}
</script>

<style lang="scss" scoped>
.page-virtual-home{
  ::v-deep {
    .ul-page__body-content{
      width: 100%;
      background-color: inherit;
    }
  }
}
.page-top{
  background-image: url('~@/assets/images/virtual/home_banner.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  .page-top-shadow{
    padding: 48px 0;
    // background-color: rgba(0,0,0,0.2);
  }
  .content{
    @include page-width;
    display: flex;
  }
  .cover{
    font-size: 0;
    img{
      height: 270px;
      width: 480px;
      border: 6px solid rgba(255, 255, 255, 0.20);
      border-radius: 10px;
      box-sizing: border-box;
    }
  }
  .detail{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-left: 28px;
    color: $--color-white;
    .title{
      font-size: 24px;
      line-height: 30px;
      font-weight: 600;
      @include ellipsis2;
    }
    .teacher{
      padding: 24px 0 12px;
      font-size: 16px;
      line-height: 24px;
    }
  }
  .info-list{
    display: flex;
    flex-wrap: wrap;
    li{
      margin-right: 36px;
      margin-top: 12px;
    }
    .value{
      font-size: 24px;
      font-weight: 600;
      line-height: 24px;
    }
    .label{
      display: flex;
      align-items: center;
      margin-top: 12px;
      line-height: 1;
      i{
        margin-right: 4px;
        font-size: 14px;
      }
    }
  }
  .bt-wrapper{
    flex: 1;
    display: flex;
    align-items: flex-end;
    margin-top: 20px;
  }
}
.main-content{
  @include page-width;
  padding: 10px 0;
  background-color: #fff;
  margin: 32px auto;
}
.tabs-wrapper{
  display: flex;
  justify-content: center;
  border-bottom: $--border-base;
}
.tabs{
  display: flex;
  .tab{
    padding: 10px 0;
    margin: 0 20px;
    line-height: 24px;
    font-size: 16px;
    cursor: pointer;
    &:hover{
      color: $--color-primary;
    }
    &.is-active{
      border-bottom: solid 3px $--color-primary;
      color: $--color-primary;
    }
  }
}
.tab-content{
  padding: 24px;
}
</style>